var spoiler_default = {
  "fontElementMap": "yszB-",
  "hideText": "_-6VAu",
  "onHoverText": "iSepd",
  "hideBlock": "fyr3v",
  "smallBlur": "RKTIh",
  "mediumBlur": "YouiC",
  "largeBlur": "SZ8ys",
  "hideBlock_gallery": "m4tF9",
  "overlay": "DlsJl",
  "overlay_gallery": "sB2Cs",
  "revealSpoilerBtn": "WQhMz",
  "isMobile": "sRx7s",
  "onHoverBtn": "vXHVG",
  "spoilerWrapper": "eqNng",
  "spoilerDescription": "M2Qpr",
  "spoilerContainer": "CKhVS",
  "spoilerContainer_Gallery": "qY9ZE"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
